import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Spinner } from '@nike/podium';

export const RequiredAuth: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const redirectTriggeredRef = useRef(false);

  useEffect(() => {
    if (!authState) return;
    if (authState.isAuthenticated) {
      redirectTriggeredRef.current = false;
      return;
    }
    if (redirectTriggeredRef.current) return;

    redirectTriggeredRef.current = true;
    const originalUri = toRelativeUrl(window.location.href, window.location.origin);
    oktaAuth.setOriginalUri(originalUri);
    oktaAuth.signInWithRedirect();
  }, [oktaAuth, authState?.isAuthenticated]);

  if (!authState || !authState?.isAuthenticated) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <Spinner aria-label="Loading" />
      </div>
    );
  }

  return (<Outlet />);
};
